module.exports = __webpack_public_path__ + "static/media/logo_events.8b397303.png";